import Layout from '@layout/Index'
import TrainingPageLayout from './layouts/TrainingPageLayout.vue'

export const trainingRoute = [
  {
    path: '/training',
    component: Layout,
    children: [
      {
        path: '',
        component: TrainingPageLayout,
        children: [
          // 培训
          {
            path: 'instruction',
            component: () => import(/* webpackChunkName: "training-instruction" */ './pages/instruction/TrainingInstructionTable.vue'),
            meta: {
              title: '培训管理',
              aiContext: 'instruction-list',
            },
          },
          {
            path: 'instruction/create',
            component: () => import(/* webpackChunkName: "training-instruction-form" */ './pages/instruction/TrainingInstructionForm.vue'),
            meta: {
              title: '新增培训',
              aiContext: 'instruction-form',
              activeMenu: '/training/instruction',
            },
          },
          {
            path: 'instruction/update/:id',
            component: () => import(/* webpackChunkName: "training-instruction-form" */ './pages/instruction/TrainingInstructionForm.vue'),
            meta: {
              title: '编辑培训',
              aiContext: 'instruction-form',
              activeMenu: '/training/instruction',
            },
          },
          {
            path: 'instruction/records/:id',
            component: () => import(/* webpackChunkName: "training-instruction-records" */ './pages/instruction/TrainingInstructionRecordTable.vue'),
            meta: {
              title: '学习记录',
              aiContext: 'instruction-records',
              activeMenu: '/training/instruction',
            },
          },
          {
            path: 'instruction/exam-records/:id/detail/:recordId',
            component: () => import(/* webpackChunkName: "training-instruction-exam-record-detail" */ './pages/instruction/TrainingInstructionExamRecordDetail.vue'),
            meta: {
              title: '考试记录详情',
              aiContext: 'instruction-exam-detail',
              activeMenu: '/training/instruction',
            },
          },
          {
            path: 'instruction/exam-records/:instructionId',
            component: () => import(/* webpackChunkName: "training-instruction-exam-records" */ './pages/instruction/TrainingInstructionExamRecordTable.vue'),
            meta: {
              title: '培训答卷记录',
              aiContext: 'instruction-exam-records',
              activeMenu: '/training/instruction',
            },
          },
          {
            path: 'instruction/bind-history/:id',
            component: () => import(/* webpackChunkName: "training-instruction-bind-history" */ './pages/instruction/TrainingInstructionBindHistory.vue'),
            meta: {
              title: '绑定历史',
              aiContext: 'instruction-bind-history',
              activeMenu: '/training/instruction',
            },
          },

          // 实习生教程
          {
            path: 'self-examination',
            component: () => import(/* webpackChunkName: "self-training-examination" */ './pages/exam/SelfTrainingExaminationTable.vue'),
            meta: {
              title: '我的问卷',
            },
          },
          {
            path: 'self-examination/:id/result/:recordId',
            component: () => import(/* webpackChunkName: "self-training-examination-result" */ './pages/exam/SelfTrainingExaminationResult.vue'),
            meta: {
              title: '考试详情',
              activeMenu: '/training/self-examination',
            },
          },
          {
            path: 'self-examination/:id',
            component: () => import(/* webpackChunkName: "self-training-examination-page" */ './pages/exam/SelfTrainingExamination.vue'),
            meta: {
              title: '考试答题',
              activeMenu: '/training/self-examination',
            },
          },
          {
            path: 'examination/:examinationId/intern/records/:recordId',
            component: () => import(/* webpackChunkName: "training-examination-intern-record-detail" */ './pages/exam/TrainingExaminationInternRecordDetail.vue'),
            meta: {
              title: '实习生答卷详情',
              activeMenu: '/training/intern-examination',
            },
          },
          {
            path: 'examination/:examinationId/intern/records',
            component: () => import(/* webpackChunkName: "training-examination" */ './pages/exam/TrainingExaminationInternRecordTable.vue'),
            meta: {
              title: '实习生答卷记录',
              aiContext: 'examination-intern-records',
            }
          },
          {
            path: 'self-course',
            component: () => import(/* webpackChunkName: "self-training-course" */ './pages/course/SelfTrainingCourseTable.vue'),
            meta: {
              title: '我的全部培训',
              aiContext: 'course-list-intern',
            },
          },
          {
            path: 'intern-course',
            component: () => import(/* webpackChunkName: "intern-training-course" */ './pages/course/InternTrainingCourseTable.vue'),
            meta: {
              title: '实习生教程管理',
              aiContext: 'course-list-intern',
            },
          },
          {
            path: 'intern-course/create',
            component: () => import(/* webpackChunkName: "intern-training-course-form" */ './pages/course/InternTrainingCourseForm.vue'),
            meta: {
              title: '创建实习生教程',
              aiContext: 'course-form-intern',
              activeMenu: '/training/intern-course',
            },
          },
          {
            path: 'intern-course/update/:id',
            component: () => import(/* webpackChunkName: "intern-training-course-form" */ './pages/course/InternTrainingCourseForm.vue'),
            meta: {
              title: '编辑实习生教程',
              aiContext: 'course-form-intern',
              activeMenu: '/training/intern-course',
            },
          },

          // 零工教程
          {
            path: 'user-course',
            component: () => import(/* webpackChunkName: "user-training-course" */ './pages/course/UserTrainingCourseTable.vue'),
            meta: {
              title: '零工教程管理',
              aiContext: 'course-list',
            },
          },
          {
            path: 'user-course/create',
            component: () => import(/* webpackChunkName: "user-training-course-form" */ './pages/course/UserTrainingCourseForm.vue'),
            meta: {
              title: '创建零工教程',
              aiContext: 'course-form',
              activeMenu: '/training/user-course',
            },
          },
          {
            path: 'user-course/update/:id',
            component: () => import(/* webpackChunkName: "user-training-course-form" */ './pages/course/UserTrainingCourseForm.vue'),
            meta: {
              title: '编辑零工教程',
              aiContext: 'course-form',
              activeMenu: '/training/user-course',
            },
          },

          // 考试
          {
            path: 'examination',
            component: () => import(/* webpackChunkName: "training-examination" */ './pages/exam/TrainingExaminationTable.vue'),
            meta: {
              title: '零工考试管理',
              aiContext: 'examination-list',
            },
          },
          {
            path: 'examination/create',
            component: () => import(/* webpackChunkName: "training-examination" */ './pages/exam/TrainingExamForm.vue'),
            meta: {
              title: '创建零工考试',
              activeMenu: '/training/examination',
            },
          },
          {
            path: 'examination/update/:id',
            component: () => import(/* webpackChunkName: "training-examination" */ './pages/exam/TrainingExamForm.vue'),
            meta: {
              title: '编辑零工考试',
              activeMenu: '/training/examination',
            },
          },
          {
            path: 'examination/exam-records/:examinationId',
            component: () => import(/* webpackChunkName: "training-examination" */ './pages/instruction/TrainingInstructionExamRecordTable.vue'),
            meta: {
              title: '零工考试答卷记录',
              aiContext: 'examination-exam-records',
              activeMenu: '/training/examination',
            },
          },

          // 实习生考试
          {
            path: 'intern-examination',
            component: () => import(/* webpackChunkName: "training-examination" */ './pages/exam/InternTrainingExaminationTable.vue'),
            meta: {
              title: '实习生考试管理',
              aiContext: 'examination-list',
            },
          },
          {
            path: 'intern-examination/create',
            component: () => import(/* webpackChunkName: "training-examination" */ './pages/exam/InternTrainingExamForm.vue'),
            meta: {
              title: '创建实习生考试',
              activeMenu: '/training/intern-examination',
            },
          },
          {
            path: 'intern-examination/update/:id',
            component: () => import(/* webpackChunkName: "training-examination" */ './pages/exam/InternTrainingExamForm.vue'),
            meta: {
              title: '编辑实习生考试',
              activeMenu: '/training/intern-examination',
            },
          },

          // 题目
          {
            path: 'question',
            component: () => import(/* webpackChunkName: "training-question" */ './pages/question/TrainingQuestionTable.vue'),
            meta: {
              title: '题目管理',
              aiContext: 'question-list',
            },
          },
          {
            path: 'question/create',
            component: () => import(/* webpackChunkName: "training-question" */ './pages/question/TrainingQuestionForm.vue'),
            meta: {
              title: '创建题目',
              activeMenu: '/training/question',
            },
          },
          {
            path: 'question/update/:id',
            component: () => import(/* webpackChunkName: "training-question" */ './pages/question/TrainingQuestionForm.vue'),
            meta: {
              title: '编辑题目',
              activeMenu: '/training/question',
            },
          },

          // 知识库
          {
            path: 'knowledge',
            component: () => import(/* webpackChunkName: "training-knowledge" */ './pages/knowledge/TrainingKnowledgeTable.vue'),
            meta: {
              title: '知识库管理',
              aiContext: 'knowledge-list',
            },
          }
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/views/training/training.route.js